import React, { useEffect } from 'react';
import { useRouter } from 'next/router';

const Promo = () => {
  const router = useRouter();
  useEffect(() => {
    if (router.isReady) {
      router.push({ pathname: `/auth/sign-up`, query: router.query });
    }
  }, [router.isReady]);

  // Could add a loader?
  return <></>;
};

export async function getStaticProps() {
  return {
    props: {},
  };
}

export default Promo;
